module.exports = __webpack_public_path__ + "static/survey-63188d135b5a81437456b1f91a58997b.mp4";